import React, { useState } from 'react';
import Viewer from '../viewer/Viewer';
import '../../App.css';
import { useOktaAuth } from '@okta/okta-react';
import SearchBar from '../layout/SearchBar';
import '../../assets/css/Viewer.css';
import '../../assets/css/Layout.css';
import '../../assets/css/Print.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchDataProvider from '../../providers/SearchDataProvider';
import NavBar from '../layout/NavBar';

import {
    faMagnifyingGlass,
    faFileArrowDown,
    faAngleLeft,
    faAngleRight,
    faClockRotateLeft,
} from '@fortawesome/free-solid-svg-icons';

import originLogo from '../../assets/img/origin-icon.svg';

const SearchMain = () => {
    const { oktaAuth, authState } = useOktaAuth();

    const [isopen, setIsOpen] = useState<boolean>(true);

    var uid: string = '';
    var userName: string = '';
    var accessToken: string = '';
    var userEmail: string = '';
    var cid: string = '';

    if (!authState) {
        return <div></div>;
    }

    if (authState.isAuthenticated) {
        userEmail = authState.accessToken.claims?.sub;
        userName = authState.accessToken.claims?.sub;
        uid = authState.accessToken.claims?.uid;
        accessToken = authState.accessToken.accessToken;
        cid = authState.accessToken.claims?.uid;
    }

    function openNav(e: React.MouseEvent<HTMLOrSVGElement>) {
        var isopened = !isopen;
        setIsOpen(isopened);
    }
    const sectionStyle = {
        marginRight: '-12px',
        marginTop: '-22em',
    };

    const sideNavIcon = isopen ? (
        <FontAwesomeIcon icon={faAngleLeft} className='nav-bar' />
    ) : (
        <FontAwesomeIcon icon={faAngleRight} className='nav-bar' onClick={(e) => openNav(e)} />
    );

    return (
        <>
            <div className='main-container'>
                <div
                    className={
                        isopen ? 'main-sidebar sidebar-opened' : 'main-sidebar sidebar-closed'
                    }
                >
                    <SearchDataProvider>
                        {isopen ? (
                            <div
                                className='sidebar-container sidebar-container-opened'
                                id='sidebarMain'
                            >
                                <SearchBar />
                            </div>
                        ) : (
                            <>
                                <div
                                    className='sidebar-container sidebar-container-opened hidden'
                                    id='sidebarMain'
                                >
                                    <SearchBar />
                                </div>
                                <div
                                    className='sidebar-container sidebar-container-closed'
                                    id='sidebarMain'
                                >
                                    <div className='sidebar-closed-container'>
                                        <div className='sidebar-header'>
                                            <div>
                                                <div>
                                                    <img
                                                        src={originLogo}
                                                        alt='company logo'
                                                        width='32px'
                                                    ></img>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='sidebar-icon'>
                                            <div>
                                                <div>
                                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='sidebar-icon'>
                                            <div>
                                                <div>
                                                    <FontAwesomeIcon icon={faFileArrowDown} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='sidebar-icon'>
                                            <div>
                                                <div>
                                                    <FontAwesomeIcon icon={faClockRotateLeft} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </SearchDataProvider>
                </div>
                <div
                    className={isopen ? 'sidebar-toggle open' : 'sidebar-toggle closed'}
                    // style={{
                    //     backgroundColor: '#4472c4',
                    //     height: 'auto',
                    //     borderTopRightRadius: '0.25rem',
                    //     minWidth: '15px',
                    //     paddingTop: '10px',
                    // }}
                    onClick={(e) => openNav(e)}
                >
                    {/* <section>{sideNavIcon}</section> */}
                </div>
                <div className='main-viewer'>
                    <section className='viewer-container'>
                        <header className='viewer-header'>
                            <NavBar></NavBar>
                        </header>
                        <Viewer isSearchBarOpen={isopen}></Viewer>
                    </section>
                </div>
            </div>
        </>
    );
};

export default SearchMain;
